import { Button, StylovyzeComposableDialog, } from '@innovyze/stylovyze/lib/components';
import { Checkbox, FormControl } from '@mui/material';
import React from 'react';
import { acceptTermsAndConditions } from '@innovyze/stylovyze/lib/actions/userContext.actions';
import { useDispatch } from 'react-redux';
import { useToggle } from '@innovyze/stylovyze/lib/hooks';
export default function TermsAndConditionsDialog({ open, loading, }) {
    const [checked, toggleChecked] = useToggle();
    const dispatch = useDispatch();
    return (React.createElement(StylovyzeComposableDialog, { title: "Terms and Conditions", open: open, onCancel: () => {
            return;
        }, footer: React.createElement(Button, { color: "primary", variant: "contained", disabled: !checked || loading, onClick: () => {
                dispatch(acceptTermsAndConditions());
            } }, "Agree to continue") },
        React.createElement(FormControl, { variant: "standard", style: {
                display: 'grid',
                gridTemplateColumns: '50px 1fr',
                width: 552,
                maxWidth: '100%',
                alignItems: 'end',
            } },
            React.createElement(Checkbox, { checked: checked, onChange: toggleChecked, color: "primary" }),
            React.createElement("div", null,
                'I agree to the ',
                React.createElement("a", { href: "https://www.autodesk.com/company/terms-of-use/en/general-terms", target: "_blank", rel: "noopener noreferrer" }, "Terms of Service"),
                ' and acknowledge the ',
                React.createElement("a", { href: "https://www.autodesk.com/company/legal-notices-trademarks/privacy-statement", target: "_blank", rel: "noopener noreferrer" }, "Privacy Statement"),
                '.'))));
}
